/**************************************************
 * Nombre:       Tarjeta_Encontraras
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Encontraras = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
            spacing={1}
        >

            <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                <img src={item.img} width={sCell ? '90%' : '100%'} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={1}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{fontSize: 18, fontWeight: 800, fontFamily: 'Raleway', lineHeight: 1.1}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontFamily: 'Roboto',fontWeight: 300, fontSize: 14, lineHeight: 1.2}}>{item.descripcion}</Typography>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Encontraras